import React from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';
import { exportToExcel } from '../utils/exportToExcel';

/**
 * Кастомный тулбар для DataGrid с поддержкой экспорта в Excel
 */
export const CustomGridToolbar = ({ rows, columns, filename = 'export.xlsx' }) => {
  const handleExportExcel = () => {
    exportToExcel(rows, columns, filename);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Button
        size="small"
        startIcon={<Download />}
        onClick={handleExportExcel}
      >
        Экспорт в Excel
      </Button>
      <GridToolbarQuickFilter
        sx={{ ml: 'auto' }}
        placeholder="Поиск..."
      />
    </GridToolbarContainer>
  );
};
